export const fileToBase64 = (file: File) =>
  new Promise<string | undefined>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () =>
      resolve(reader.result ? String(reader.result) : undefined);
    reader.onerror = (error) => reject(error);
  });
